import React, { useEffect, useState } from "react";
import { View, TouchableWithoutFeedback } from "react-native";
import { useSelector } from "react-redux";
import colors from "@constants/color";
import Text from "@components/CustomText";
import { getTlUser } from "@services/api";
import { fonts } from "../constants/metrics";
import styles from "./styles/headerStyles";
import { VIEW_SEARCH } from "../constants/analyticsEvents";
import BackButton from "./BackButton";

const HeaderWithBackAndTitle = ({
  headertitle,
  subHeaderTitle,
  headerStyle,
  navigation,
  route,
  isTransparent = false,
  headerStaticName = "",
  dynamicTitleRead = false,
  rightIcon,
  rightIconClickRedirect = "",
  rightComponent = <View />,
  navState = {},
  headerColor = "#fff",
  hideShadow = false,
  shouldEmitEvent = false,
  RightButton,
  goingBackHandler,
  alwaysEnable = false,
  IsRightIconDropDown,
  numberOfLines = 0,
  bottomComponent = <View />,
}) => {
  const { headerTitle: dynamicTitleFromStore = null } =
    useSelector(({ configReducer }) => configReducer.appSettings) || {};

  const { userForOrder = {} } = useSelector(({ cart }) => cart);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!userForOrder.user_id) {
      return;
    }

    getTlUser(userForOrder.user_id)
      .then(({ data }) => {
        setUser(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [userForOrder]);

  const renderTitle = (title) => {
    switch (title) {
      case "about-us":
        return "About Us";
      case "contact-us":
        return "Contact Us";

      default:
        return "";
    }
  };

  return (
    <View>
      <View
        style={[
          isTransparent ? styles.transParentClass : styles.containerPadding,
          { flexDirection: "row" },
          { backgroundColor: headerColor },
          hideShadow
            ? {
                elevation: 0,
              }
            : {},
        ]}
      >
        <BackButton
          onPress={goingBackHandler ?? navigation.goBack}
          alwaysEnable={alwaysEnable}
        />
        <View
          style={{
            marginLeft: 4,
            marginBottom: 2,
            flex: 1,
          }}
        >
          <Text
            variant="title_18"
            numberOfLines={numberOfLines}
            style={[
              {
                fontSize:
                  route.name === "AddUser"
                    ? styles.customerHeaderTitle.fontSize
                    : fonts.content1,
              },
              headerStyle || null,
            ]}
          >
            {headertitle ||
              (dynamicTitleRead && dynamicTitleFromStore) ||
              renderTitle(headerStaticName)}
          </Text>
          {subHeaderTitle ? (
            <Text
              style={{
                fontSize: 14,
                fontFamily: "NotoSansDevanagari-Regular",
                color: colors.lightBlack,
                lineHeight: 16,
              }}
            >
              {subHeaderTitle}
            </Text>
          ) : (
            <></>
          )}
        </View>

        <View
          style={{
            position: "absolute",
            right: 0,
            minWidth: 40,
            alignItems: "center",
            marginRight: 12,
          }}
        >
          {rightComponent}
        </View>
        {IsRightIconDropDown && IsRightIconDropDown()}
        {RightButton && (
          <View
            style={{
              position: "absolute",
              right: 10,
              minWidth: 40,
              alignItems: "center",
            }}
          >
            <RightButton />
          </View>
        )}
        {rightIcon && (
          <View
            style={{
              position: "absolute",
              right: 0,
              minWidth: 40,
              alignItems: "center",
            }}
          >
            <TouchableWithoutFeedback
              onPress={() => {
                rightIconClickRedirect
                  ? navigation.navigate(rightIconClickRedirect, navState)
                  : null;
              }}
              eventName={shouldEmitEvent && VIEW_SEARCH}
              eventPayload={
                shouldEmitEvent &&
                user && {
                  customer_id: user.user_id ? user.user_id : "",
                  customer_name: user.user_name ? user.user_name : "",
                  customer_phone_number: user.user_phone ? user.user_phone : "",
                  screen: "order",
                }
              }
            >
              <View
                style={{
                  padding: 8,
                  paddingHorizontal: 16,
                }}
              >
                {rightIcon}
              </View>
            </TouchableWithoutFeedback>
          </View>
        )}
      </View>
      {bottomComponent}
    </View>
  );
};

export default HeaderWithBackAndTitle;
